import { useEffect, useState } from "react";

function getDefaultLanguage() {
    const value = localStorage.getItem('i18nextLng');

    if (value !== '') {
        console.log(value);
        return value
    }

    return 'en';
}

function useLanguageToggle() {
    const [lng, setLng] = useState(getDefaultLanguage());

    useEffect(() => {
        console.log("useEffect running...");
        setLng(lng)
    }, [lng])

    return {
        lng,
        setLng
    }
}

export default useLanguageToggle;